/* 表示されているURL取得 */
const currentUrl = location.pathname;
const navPCElement = document.querySelectorAll('.js-activeProPC a');
const navSPElement = document.querySelectorAll('.js-activeProSP li');
let prevNav = document.querySelector('.pagination-prev');
let nextNav = document.querySelector('.pagination-next');

navPCElement.forEach((element,index) => {
  /* URLとリンクのhrefが同じなら */
  if (element.href.indexOf(currentUrl) != -1 ) {
    element.querySelector('.pagination_link_text').classList.add('activeNavigation');
    navSPElement[index].remove();

    /* prevとnextのURLを設定. 現在の表示URLの前と後ろを判定 */
    if (index+1 == navPCElement.length) {
      /* 最後のリンク */
      prevNav.href = navPCElement[index-1].pathname;
      nextNav.href = navPCElement[0].pathname;
    } else if (index+1 == 1) {
      /* 最初のリンク */
      prevNav.href = navPCElement[navPCElement.length-1].pathname;
      nextNav.href = navPCElement[index+1].pathname;
    } else {
      prevNav.href = navPCElement[index-1].pathname;
      nextNav.href = navPCElement[index+1].pathname;
    }
  }
});

document.addEventListener("DOMContentLoaded", function() {

  /* 初期表示フェードイン */
  document.querySelector('.main-content-wrapper').classList.remove('mod-invisible');

  /* =====================
    選手画像を時間経過と共に
    切り替える処理
  ===================== */
  const playerVisualChageTime = 5000; // 選手画像を切り替えるインターバル
  function changePlayerImages() {
    const playerVisuals = document.querySelectorAll('.player-main-visuals__player');
    let playerVisualCount = 0; 

    setInterval(function(){
      playerVisualCount++;
      if(playerVisualCount == playerVisuals.length){
        playerVisualCount = 0;
      }
      for(let i=0; i<playerVisuals.length; i++){
        playerVisuals[i].classList.remove('add-visible');
      }
      playerVisuals[playerVisualCount].classList.add('add-visible');
    },playerVisualChageTime)
  }
  changePlayerImages();
});
